import { Injectable, inject } from '@angular/core';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { WidgetRefreshService } from '@frontend/sports/widget/core/feature';
import { OnAppInit } from '@frontend/vanilla/core';

import { HomeRefreshTrigger } from './home-refresh-trigger';

@Injectable({ providedIn: 'root' })
export class WidgetRegistrationService implements OnAppInit {
    private refreshRegistry = inject(WidgetRefreshService);
    private refresh = inject(HomeRefreshTrigger);

    onAppInit(): void {
        this.refreshRegistry.registerTrigger(RouteTag.Lobby, this.refresh);
    }
}
